export default __webpack_public_path__ + "static/media/trending-header-gold-outline.b75deb1b.svg";